'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require ('materialize-css');
require ('slick-carousel');

import swal from 'sweetalert';
//importarScript("js/swal.js");

var contLogin,campo,emailRegex;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
    $('#sliderBanner').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        fade: true,
    });
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('.btnPaqueteLanding').click(function () {
   $('#type').val('Quiero Plan Landing')
});

$('.btnPaqueteOther').click(function () {
    $('#type').val('Quiero Otros Planes')
});

$('.btnFormContacto').on('click',function () {
    $('#formContacto').submit();
});

$("#formContacto").on('submit', function (e) {
    e.preventDefault();
    $('#type').removeClass('error');
    $('#name').removeClass('error');
    $('#cellphone').removeClass('error');
    $('#email').removeClass('error');
    $('#country').removeClass('error');

    contLogin = 1;
    if ( $.trim($("#type").val()) == "" ) {
        contLogin = 0;
        $('#type').addClass('error');
    }

    if ( $.trim($("#name").val()) == "" ) {
        contLogin = 0;
        $('#name').addClass('error');
    }

    if ( $.trim($("#cellphone").val()) == "" ) {
        contLogin = 0;
        $('#cellphone').addClass('error');
    }

    if ( $.trim($("#email").val()) == "" ) {
        contLogin = 0;
        $('#email').addClass('error');
    }

    if ( $.trim($("#country").val()) == "" ) {
        contLogin = 0;
        $('#country').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }
    /*
    campo  = $("#email").val();
    emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (emailRegex.test(campo)) {
        $('#email').removeClass('error');
    } else {
        $('#email').addClass('error');
        swal({
            text: "Debe digitar un correo electrónico valido",
            icon: imageURL,
            button: "OK",
        });
        document.getElementById("emailCon").focus();
        return false;
    }*/

    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    $.ajax({
        url: https + "contact",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContacto")[0].reset();
                swal({
                    text: "Muchas Gracias \n Pronto nos pondremos en contacto con usted",
                    icon: "success",
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js